import React from 'react';
import styled from 'styled-components';
import { ReactComponent as FileRemove } from '@/assets/images/common/FileRemove.svg';
import SolidButton from '@/components/ButtonComponent/SolidButton';
import GlobalAlertPrescriptionModified, {
  AlertPrescriptionModifiedProps
} from './GlobalAlertPrescriptionModified';
import { useHistory } from 'react-router';
import { useQueryClient } from 'react-query';
import { useRecoilState } from 'recoil';
import { notificationState } from '@/recoil/notification';

const AlertPrescriptionModified = (props: AlertPrescriptionModifiedProps) => {
  const { isVisible, title, body, orderExternalId, isPaid } = props;
  const history = useHistory();
  const queryClient = useQueryClient();
  const [notification, setNotification] = useRecoilState(notificationState);

  const handleRefresh = async () => {
    setNotification({ ...notification, recent: null });
    await queryClient.refetchQueries('preparingOrders');
    await queryClient.refetchQueries('requestedOrders');
    await queryClient.refetchQueries('order');
  };

  const handleModalClose = async () => {
    await handleRefresh();

    GlobalAlertPrescriptionModified.hide();
  };

  const handleCheckModifiedPrescriptions = async () => {
    await handleRefresh();

    if (isPaid === false) {
      history.push(`/requested/${orderExternalId}`);
      GlobalAlertPrescriptionModified.hide();
      return;
    }
    history.push(`/preparing/${orderExternalId}`);

    GlobalAlertPrescriptionModified.hide();
  };

  return (
    <>
      {isVisible && (
        <Background>
          <div>
            <div>
              <FileRemove />
            </div>
            <h1>{title}</h1>
            <h2>{body}</h2>
            <ButtonContainer>
              <SolidButton
                type={'WHITE'}
                style={{ padding: '0 27px', boxSizing: 'border-box' }}
                onClick={handleModalClose}>
                나중에 확인하기
              </SolidButton>
              <SolidButton
                type={'RED'}
                style={{ padding: '0 27px', boxSizing: 'border-box' }}
                onClick={handleCheckModifiedPrescriptions}>
                수정된 처방전 확인
              </SolidButton>
            </ButtonContainer>
          </div>
        </Background>
      )}
    </>
  );
};

export default AlertPrescriptionModified;

const Background = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: ${({ theme }) => theme.DF_COLOR.DIMMED80};
  display: flex;
  justify-content: center;
  align-items: center;

  & > div > div {
    display: flex;
    justify-content: center;
  }

  h1 {
    color: ${({ theme }) => theme.DF_COLOR.WHITE};
    ${({ theme }) => theme.DF_TYPOGRAPHY.UI132SB};
    text-align: center;
    margin: 35px 0 16px 0;
  }

  h2 {
    color: ${({ theme }) => theme.DF_COLOR.GRAY200};
    ${({ theme }) => theme.DF_TYPOGRAPHY.UI20R};
    text-align: center;
    margin: 0;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
`;
